// extracted by mini-css-extract-plugin
export default {"app":"App_app__OeOfy","desktop_header":"App_desktop_header__wWo5y","mobile_header":"App_mobile_header__SrCEg"};